export default __webpack_public_path__ + "static/media/medal.92baaf20.png";